import { checkOrCreateBookByDate, computeBookDate } from './book';
import { http } from "@/api/http";

// Возвращает плоский список пользователей из book/check/
export async function listBookUsers(params = {}) {
  const { date, is_archived } = params || {};
  const dateISO = date || computeBookDate();
  const ctx = await checkOrCreateBookByDate(dateISO);

  let items = Array.isArray(ctx?.users) ? ctx.users : [];
  if (typeof is_archived === 'boolean') {
    items = items.filter(x => !!x.is_archived === is_archived);
  }
  // По ТЗ 03.09.2026: 2 раздел КПС — только военные, без админов/суперюзеров.
  // Страховка: даже если бэк вернул связки на суперов (историческая книга) —
  // фронт их скроет.
  items = items.filter(x => {
    const u = x?.user || {}
    return !u.is_superuser && !u.is_staff && !u.is_system_user
  });

  // По ТЗ 02.09.2026: PlanView (панель выбора состава ПН) ждёт вложенный `user`
  // с флагами is_stpn / sentry_leader_date — иначе секция «СТПН» всегда пустая.
  // Возвращаем и плоские поля (совместимость с существующими вьюхами), и nested `user`.
  return items.map((entry) => {
    const u = entry?.user || {};
    return {
      id: entry?.id ?? u?.id,
      book_user_id: entry?.id,
      user_id: u?.id,
      user: u,
      personal_number: u?.personal_number ?? '',
      is_archived: !!entry?.is_archived,
      is_reinforcement: !!entry?.is_reinforcement,
      rank: u?.rank || '',
      position: u?.position || '',
      fio: u?.full_name || '',
      full_name: u?.full_name || '',
      birth_date: u?.birth_date || '',
      call_date: u?.service_start_date || '',
      arrive_from: u?.arrival_info || '',
      depart_to: u?.departure_info || '',
      order_ref: u?.appointment_info || '',
      note: entry?.description || '',
      is_stpn: !!u?.is_stpn,
      sentry_leader_date: u?.sentry_leader_date || null,
      stpn_type: u?.stpn_type || null,
    };
  });
}

export async function updateBookUser(id, payload) {
  const { data } = await http.patch(`book/users/${id}/`, payload);
  return data;
}

export async function archiveUser(id) {
  return updateBookUser(id, { is_archived: true });
}

export async function restoreUser(id) {
  return updateBookUser(id, { is_archived: false });
}

// По ТЗ 03.09.2026 (4 раздел «Прибыло на усиление»):
// переключение флага прикомандирования на записи BookUser.
export async function setReinforcement(id, isReinforcement) {
  return updateBookUser(id, { is_reinforcement: !!isReinforcement });
}

// Алиасы для совместимости с старыми импортами во вьюхах
export function archiveBookUser(id) {
  return archiveUser(id);
}
export function restoreBookUser(id) {
  return restoreUser(id);
}
